<template>
  <div v-if="productInfo.goods" class="fix-bottom">
    <!-- 团购 -->
    <div
      :class="{ 'show-countdown': showBottomCountdown }"
      v-if="
        productInfo.group_set_info &&
        productInfo.group_set_info.activityStatus === 2
      "
    >
      <div v-if="isH5" class="h5-group-fix-bottom fix-bottom-wrap">
        <GroupCountDown
          v-show="showBottomCountdown"
          v-if="productInfo.enrollment === null"
          key="h5-bottom"
          class="countdown-bottom"
          :endTime="productInfo.group_set_info.endTime"
        />
        <FooterOrgInfo
          key="h5-group"
          :orgInfo="orgInfo"
          :orgId="productInfo.org_id || ''"
          :showOrgName="false"
        />
        <!-- 已报名 -->
        <button
          @click="jumpStudy"
          class="sign-up-btn-disable"
          v-if="productInfo.enrollment !== null"
        >
          去学习
        </button>
        <!-- 已参团 -->
        <div class="user-group-info" v-else-if="isJoiningGroup">
          <button @click="goGroupInfo(userGroupInfo.group_id)" class="info-btn">
            您已参团 <br />
            还差 <span>{{ userGroupInfo.diffNum }}</span> 人参团
          </button>
          <button
            @click="shareGroup(userGroupInfo.group_id)"
            v-preventReClick
            class="share-group-btn"
          >
            分享拼团给好友
          </button>
        </div>
        <!-- 未报名 -->
        <div class="sign-up-btn" v-else>
          <button v-preventReClick @click="signUp()" class="not-join-btn">
            <span
              class="price"
              v-html="splitPrice(productInfo.goods.price)"
            ></span>
            <span class="text">原价报名</span>
          </button>
          <button @click="signUp(0)" class="join-btn" v-preventReClick>
            <span
              class="price"
              v-html="splitPrice(productInfo.group_set_info.price)"
            ></span>
            <span class="text">发起拼团</span>
          </button>
        </div>
      </div>
      <div
        v-else
        class="pc-group-fix-bottom fix-bottom-wrap"
        :class="{ 'elec-group-fix-bottom': isElectron || isMGAppInPad }"
      >
        <GroupCountDown
          v-if="productInfo.enrollment === null"
          v-show="showBottomCountdown"
          key="bottom"
          class="countdown-bottom"
          :endTime="productInfo.group_set_info.endTime"
        />
        <FooterOrgInfo
          :class="{ 'group-footer-org': isJoiningGroup }"
          key="group"
          :orgInfo="orgInfo"
          :orgId="productInfo.org_id || ''"
        />
        <!-- 已报名 -->
        <button
          @click="jumpStudy"
          class="sign-up-btn-disable"
          v-if="productInfo.enrollment !== null"
        >
          去学习
        </button>
        <div class="user-group-info" v-else-if="isJoiningGroup">
          <button @click="goGroupInfo(userGroupInfo.group_id)" class="info-btn">
            您已参团 <br v-if="isH5" />
            还差 <span>{{ userGroupInfo.diffNum }}</span> 人参团
          </button>
          <button
            @click="shareGroup(userGroupInfo.group_id)"
            v-preventReClick
            class="share-group-btn"
          >
            分享拼团给好友
          </button>
        </div>
        <!-- 未报名 -->
        <div class="sign-up-btn" v-else>
          <button v-preventReClick @click="signUp()" class="not-join-btn">
            <span class="price"
              ><i>￥</i>{{ productInfo.goods.price / 100 }}</span
            >
            <span class="text">原价报名</span>
          </button>
          <button @click="signUp(0)" class="join-btn" v-preventReClick>
            <span class="price"
              ><i>￥</i>{{ productInfo.group_set_info.price / 100 }}</span
            >
            <span class="text">发起拼团</span>
          </button>
        </div>
      </div>
    </div>
    <!-- 普通报名 -->
    <div
      v-else
      class="fix-bottom-wrap"
      :class="{
        'h5-normal-fix-bottom': isH5,
        'pc-normal-fix-bottom': !isH5,
        'elec-normal-fix-bottom': isElectron || isMGAppInPad,
      }"
    >
      <FooterOrgInfo
        key="normal"
        :orgInfo="orgInfo"
        :orgId="productInfo.org_id || ''"
      />
      <div class="right">
        <span class="price-wrap">
          <Price
            v-if="!isH5 && productInfo.activity_type === 2"
            :size="isElectron || isMGAppInPad ? 'SL1' : 'ML2'"
            :activePrice="productInfo.promotion_info.promotion_price"
            :originPrice="productInfo.goods.price"
          />
          <span
            class="price just-price"
            v-else
            v-html="handleProductPrice"
          ></span>
        </span>
        <button
          class="sign-up-btn"
          v-if="productInfo.enrollment === null"
          v-preventReClick
          @click="signUp()"
        >
          {{ productInfo.goods.fee_type === 1 ? "免费领取" : "立即报名" }}
        </button>
        <button @click="jumpStudy" class="sign-up-btn-disable" v-else>
          去学习
        </button>
      </div>
    </div>
    <!-- 分享弹窗 -->
    <ShareDrawer ref="shareGroupDrawer" :productInfo="productInfo" />
  </div>
</template>

<script>
import { jsToFlutter } from "@saas/components/src/utils/js-to-flutter";
import {
  isH5,
  clipboard,
  isMGAppInPad,
  GroupCountDown,
  isHXApp,
  ShareDrawer,
  isQQ,
  isWeChat,
  Price,
} from "@saas/components";
import FooterOrgInfo from "@saas/pages/src/product-details/components/FooterOrgInfo";
export default {
  props: {
    productInfo: {
      type: Object,
      default: () => {
        return {};
      },
    },
    orgInfo: {
      type: Object,
      default: () => {
        return {};
      },
    },
    showBottomCountdown: {
      type: Boolean,
      default: false,
    },
    isJoiningGroup: {
      type: Boolean,
      default: false,
    },
    userGroupInfo: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {
      isH5: false,
      isElectron: false,
      isMGAppInPad: false,
      isHXApp: false,
      isWeChat: isWeChat(),
      isQQ: isQQ(),
    };
  },
  mounted() {
    this.isH5 = isH5();
    this.isElectron = window.isElectron;
    this.isMGAppInPad = isMGAppInPad();
    this.isHXApp = isHXApp();
  },
  methods: {
    jumpStudy() {
      // 统一跳转学习中心-课程详情页
      // if (
      //   this.productInfo?.unit_list?.length &&
      //   this.productInfo.unit_list[0]?.lesson_list?.length
      // ) {
      //   let { id, unit_id, course_id } =
      //     this.productInfo.unit_list[0]?.lesson_list[0];
      //   if (this.isHXApp) {
      //     let params = {
      //       course_id,
      //       unit_id,
      //       lesson_id: id,
      //     };
      //     jsToFlutter("videoPlayer", params);
      //   } else {
      //     this.$router.push(`/video-play/${course_id}/${unit_id}/${id}`);
      //   }
      // } else {
      if (this.isHXApp) {
        let params = {
          courseId: this.productInfo.id,
        };
        let otherData = {
          name: "myCourseDetail",
        };
        jsToFlutter("openPage", params, otherData);
      } else {
        this.$router.push({
          name: "myCourseDetail",
          params: {
            id: this.productInfo.id,
          },
        });
      }
      // }
    },
    copyShareUrl(group_id) {
      const content = `点击链接，一起 ${
        this.productInfo.group_set_info.price / 100
      } 元拼团购买原价 ${this.productInfo.goods.price / 100} 元的课程《${
        this.productInfo.course_name
      }》，链接：${process.env.VUE_APP_SAAS_WEB_URL}/group-share/${group_id}`;
      const _this = this;
      clipboard(content, () => {
        _this.$message.success("链接已复制，可以发给好友啦");
      });
    },
    goGroupInfo(group_id) {
      let url = `/group-info/${group_id}`;
      this.$router.push(url);
    },
    shareGroup(group_id) {
      const shareContent = `点击链接，一起 ${
        this.productInfo.group_set_info.price / 100
      } 元拼团购买原价 ${this.productInfo.goods.price / 100} 元的课程《${
        this.productInfo.course_name
      }》吧！`;
      const shareUrl = `${process.env.VUE_APP_SAAS_WEB_URL}/group-share/${this.userGroupInfo?.group_id}`;
      if (this.isHXApp) {
        let { course_name, id, cover_url, goods = {} } = this.productInfo;
        jsToFlutter("shareAction", {
          courseName: course_name || "",
          courseUrl: shareUrl,
          coverUrl: cover_url,
          courseId: id,
          postUrl: this.$refs?.courseCard?.posterUrl || "",
          price: goods.price,
          shareContent,
        });
      } else if (this.isH5 && !this.isWeChat && !this.isQQ) {
        this.$refs.shareGroupDrawer.openDrawer({
          shareUrl, // 分享地址
          title: shareContent, // 分享标题
          pic: this.productInfo.cover_url,
          linkShowTitle: true,
          canJoinNum: this.userGroupInfo.diffNum,
          copyTostMsg: "链接已复制，可以发给好友啦",
        });
      } else {
        this.copyShareUrl(group_id);
      }
    },
    signUp(params) {
      this.$emit("signUp", params);
    },
  },
  components: {
    FooterOrgInfo,
    GroupCountDown,
    ShareDrawer,
    Price,
  },
  computed: {
    splitPrice() {
      return (price) => {
        let [integer, decimal] = (Number(price) / 100).toString().split(".");
        let str = `<span class="unit">￥</span><span class="integer">${integer}</span>`;
        if (decimal) {
          str += `<span class="decimal">.${decimal}</span>`;
        }
        return str;
      };
    },
    handleProductPrice() {
      let cont = "";
      if (this.productInfo.goods.fee_type === 1) {
        cont = "免费";
      } else if (this.productInfo.activity_type === 2) {
        // 促销价
        cont = `<i>￥</i>${
          this.productInfo.promotion_info.promotion_price / 100
        }`;
      } else {
        cont = `<i>￥</i>${this.productInfo.goods.price / 100}`;
      }
      return cont;
    },
  },
};
</script>

<style lang="scss" scoped>
.fix-bottom > div {
  z-index: 9;
}
// 底部倒计时
.show-countdown {
  .pc-group-fix-bottom {
    border-radius: 24px 0px 0px 0px;
  }
  .elec-group-fix-bottom {
    border-radius: 16px 0px 0px 0px;
  }
}
// 团购
.pc-group-fix-bottom {
  position: fixed;
  bottom: 0;
  height: 100px;
  padding: 0 30px;
  background: #fff;
  width: 100%;
  max-width: 800px;
  border-radius: 24px 24px 0px 0px;
  box-shadow: 0px -6px 16px 0px rgba(102, 116, 107, 0.1);
  display: flex;
  align-items: center;
  justify-content: space-between;
  .group-footer-org {
    width: 280px;
  }
  .sign-up-btn {
    width: 195px;
    height: 50px;
    background: url("../../../assets/images/product-details/group-sign-btn.png");
    background-size: 100% 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .text {
      font-weight: 500;
      font-size: 12px;
      color: #747573;
      line-height: 17px;
    }
    .price {
      line-height: 1;
      font-weight: 600;
      font-size: 16px;
      color: #f03349;
      i {
        font-style: normal;
        font-size: 10px;
      }
    }
    button {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: space-between;
      padding: 7px 0;
      height: 100%;
    }
  }
  .not-join-btn {
    width: 95px;
  }
  .join-btn {
    width: 90px;
    span {
      color: #fff !important;
    }
  }
  .user-group-info {
    flex: 1;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .info-btn {
      font-weight: 500;
      font-size: 16px;
      color: $saas-text-color;
      line-height: 22px;
      position: relative;
      padding-right: 23px;
      span {
        color: #f03349;
      }
      &::after {
        position: absolute;
        content: " ";
        right: 0;
        top: 50%;
        display: block;
        transform: translateY(-50%);
        width: 16px;
        height: 16px;
        background: url("../../../assets/images/product-details/text-btn-arrow.png");
        background-size: 100% 100%;
      }
    }
  }
  .share-group-btn {
    position: relative;
    top: -8px;
    width: 169px;
    height: 64px;
    background: url("../../../assets/images/product-details/share-group-btn.png");
    background-size: 100% 100%;
    display: flex;
    align-items: center;
    padding: 14px 37px 0 20px;
    font-weight: 600;
    font-size: 16px;
    color: #ffffff;
    line-height: 22px;
  }
  // 已报名
  .sign-up-btn-disable {
    width: 120px;
    height: 50px;
    background: linear-gradient(132deg, #00eb81 0%, #00c89d 100%);
    background-size: 100% 100%;
    font-weight: 500;
    font-size: 16px;
    color: #ffffff;
    line-height: 22px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .countdown-bottom {
    position: absolute;
    right: 0;
    top: -36px;
    height: auto;
    padding: 10px;
    background: #ffffff;
    border-radius: 17px 17px 0px 0px;
  }
}
.elec-group-fix-bottom {
  position: fixed;
  bottom: 0;
  background: #fff;
  width: 100%;
  max-width: 800px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 70px;
  padding: 0 24px;
  box-shadow: 0px 2px 16px 0px rgba(102, 116, 107, 0.1);
  border-radius: 16px 16px 0px 0px;
  .group-footer-org {
    width: 280px;
  }
  .sign-up-btn {
    width: 195px;
    height: 44px;
    background: url("../../../assets/images/product-details/group-sign-btn.png");
    background-size: 100% 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .text {
      font-weight: 500;
      font-size: 12px;
      color: #747573;
      line-height: 17px;
    }
    .price {
      line-height: 1;
      font-weight: 500;
      font-size: 16px;
      color: #f03349;
      i {
        font-style: normal;
        font-size: 10px;
      }
    }
    button {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: space-between;
      padding: 4px 0;
      height: 100%;
    }
  }
  .not-join-btn {
    width: 95px;
  }
  .join-btn {
    width: 90px;
    span {
      color: #fff !important;
    }
  }
  .user-group-info {
    flex: 1;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .info-btn {
      font-weight: 500;
      color: $saas-text-color;
      font-size: 14px;
      line-height: 20px;
      position: relative;
      padding-right: 23px;
      span {
        color: #f03349;
      }
      &::after {
        position: absolute;
        content: " ";
        right: 0;
        top: 50%;
        display: block;
        transform: translateY(-50%);
        width: 16px;
        height: 16px;
        background: url("../../../assets/images/product-details/text-btn-arrow.png");
        background-size: 100% 100%;
      }
    }
  }
  .share-group-btn {
    position: relative;
    top: -5px;
    width: 139px;
    height: 45px;
    background: url("../../../assets/images/product-details/share-group-btn.png");
    background-size: 100% 100%;
    display: flex;
    align-items: center;
    padding: 12px 0 0 12px;
    font-weight: 500;
    font-size: 14px;
    color: #ffffff;
    line-height: 20px;
  }
  // 已报名
  .sign-up-btn-disable {
    width: 130px;
    height: 40px;
    background: linear-gradient(132deg, #00eb81 0%, #00c89d 100%);
    background-size: 100% 100%;
    font-weight: 500;
    font-size: 14px;
    line-height: 20px;
    color: #ffffff;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .countdown-bottom {
    position: absolute;
    right: 0;
    top: -36px;
    height: auto;
    padding: 10px;
    background: #ffffff;
    border-radius: 17px 17px 0px 0px;
  }
}
.h5-group-fix-bottom {
  position: fixed;
  bottom: 0;
  background: #fff;
  width: 100%;
  background: #ffffff;
  border: 0.01rem solid #efefef;
  padding: 0.27rem 0.32rem 0.85rem 0.45rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  // 已报名
  .sign-up-btn-disable {
    width: 7.47rem;
    height: 1.28rem;
    font-weight: 500;
    font-size: 0.43rem;
    color: #ffffff;
    line-height: 0.6rem;
    display: flex;
    align-items: center;
    justify-content: center;
    background: linear-gradient(132deg, #00eb81 0%, #00c89d 100%);
    background-size: 100% 100%;
    opacity: 1;
  }
  // 已参团
  .user-group-info {
    display: flex;
    align-items: center;
    .info-btn {
      position: relative;
      text-align: left;
      font-weight: 500;
      font-size: 0.4rem;
      color: #0d1400;
      line-height: 0.56rem;
      margin-right: 0.99rem;
      span {
        color: #f03349;
      }
      &::after {
        position: absolute;
        content: "";
        right: -0.5rem;
        bottom: 0.04rem;
        display: block;
        // transform: translateY(-50%);
        width: 0.4rem;
        height: 0.4rem;
        background: url("../../../assets/images/product-details/text-btn-arrow.png");
        background-size: 100% 100%;
      }
    }
    .share-group-btn {
      width: 4.32rem;
      height: 1.28rem;
      background: url("../../../assets/images/product-details/h5-share-group-btn.png");
      background-size: 100% 100%;
      font-weight: 500;
      font-size: 0.43rem;
      color: #ffffff;
      line-height: 1;
      display: flex;
      align-items: center;
      justify-content: start;
      padding-left: 0.44rem;
    }
  }
  //未报名
  .sign-up-btn {
    width: 7.2rem;
    height: 1.4rem;
    padding-bottom: 0.12rem;
    background: url("../../../assets/images/product-details/h5-group-btn.png");
    background-size: 100% 100%;
    display: flex;
    align-items: center;
    .not-join-btn {
      width: 3.33rem;
      margin-right: 0.52rem;
      padding-left: 0.44rem;
      .price {
      }

      .text {
        font-weight: 400;
        font-size: 0.32rem;
        color: #747573;
        line-height: 0.44rem;
      }
    }
    .join-btn {
      flex: 1;
      align-items: center;
      margin-right: 0.27rem;
      .text {
        font-weight: 400;
        font-size: 0.32rem;
        color: #ffffff;
        line-height: 0.44rem;
      }
    }
    ::v-deep {
      .not-join-btn {
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        .unit {
          font-weight: 800;
          font-size: 0.37rem;
          color: #ff265c;
          line-height: 1;
        }
        .integer {
          font-weight: 800;
          font-size: 0.59rem;
          color: #ff265c;
          line-height: 1;
        }
        .decimal {
          font-weight: 800;
          font-size: 0.4rem;
          color: #ff265c;
          line-height: 1;
        }
      }
      .join-btn {
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        color: #fff;
        .unit {
          font-weight: 800;
          font-size: 0.37rem;
          line-height: 1;
        }
        .integer {
          font-weight: 800;
          font-size: 0.59rem;
          line-height: 1;
        }
        .decimal {
          font-weight: 800;
          font-size: 0.4rem;
          line-height: 1;
        }
      }
    }
  }
  // 倒计时
  .countdown-bottom {
    position: absolute;
    right: 0;
    top: 0;
    transform: translateY(-100%);
    height: auto;
    padding: 0.27rem;
    background: #fff;
    border-radius: 0.45rem 0.45rem 0rem 0rem;
    border: 0.01rem solid #efefef;
  }
}

// 普通报名
.pc-normal-fix-bottom {
  position: fixed;
  bottom: 0;
  height: 100px;
  padding: 0 30px;
  background: #fff;
  width: 100%;
  max-width: 800px;
  border-radius: 24px 24px 0px 0px;
  box-shadow: 0px -6px 16px 0px rgba(102, 116, 107, 0.1);
  display: flex;
  justify-content: space-between;
  align-items: center;
  .right {
    display: flex;
    align-items: center;
  }
  .sign-up-btn {
    width: 120px;
    height: 50px;
    background: url("../../../assets/images/product-details/normal-btn-bg.png");
    background-size: 100% 100%;
    font-weight: 600;
    font-size: 16px;
    color: #ffffff;
    line-height: 22px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .price-wrap {
    margin-right: 20px;
  }
  ::v-deep .price.just-price {
    line-height: 1;
    font-weight: 600;
    font-size: 24px;
    color: #f03349;
    i {
      font-size: 12px;
      font-style: normal;
    }
  }
  // 已报名
  .sign-up-btn-disable {
    width: 120px;
    height: 50px;
    background: linear-gradient(132deg, #00eb81 0%, #00c89d 100%);
    font-weight: 600;
    font-size: 16px;
    color: #ffffff;
    line-height: 22px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 12px;
  }
}
.elec-normal-fix-bottom {
  position: fixed;
  bottom: 0;
  background: #fff;
  width: 100%;
  max-width: 800px;
  height: 70px;
  padding: 0 24px;
  box-shadow: 0px 2px 16px 0px rgba(102, 116, 107, 0.1);
  border-radius: 16px 16px 0px 0px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  .right {
    display: flex;
    align-items: center;
  }
  .sign-up-btn {
    background: url("../../../assets/images/product-details/normal-btn-bg.png");
    background-size: 100% 100%;
    color: #ffffff;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 130px;
    height: 40px;
    font-weight: 600;
    font-size: 14px;
    line-height: 20px;
  }
  ::v-deep .price.just-price {
    line-height: 1;
    font-weight: 600;
    font-size: 18px;
    color: #f03349;
    i {
      font-size: 12px;
      font-style: normal;
    }
    margin-right: 20px;
  }
  // 已报名
  .sign-up-btn-disable {
    width: 130px;
    height: 40px;
    font-size: 14px;
    line-height: 20px;
    background: linear-gradient(132deg, #00eb81 0%, #00c89d 100%);
    background-size: 100% 100%;
    font-weight: 500;
    color: #ffffff;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
.h5-normal-fix-bottom {
  position: fixed;
  bottom: 0;
  height: 1.97rem;
  padding: 0 0.53rem 0 0.32rem;
  background: #fff;
  width: 100%;
  max-width: 100%;
  box-shadow: 0rem -0.16rem 0.43rem 0rem rgba(102, 116, 107, 0.1);
  border-radius: 0.64rem 0.64rem 0rem 0rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  .right {
    display: flex;
    align-items: center;
  }
  .sign-up-btn {
    width: 4.19rem;
    height: 1.33rem;
    background: url("../../../assets/images/product-details/normal-btn-bg.png");
    background-size: 100% 100%;
    font-weight: 600;
    font-size: 16px;
    color: #ffffff;
    line-height: 22px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 0.66rem;
  }
  ::v-deep .price {
    line-height: 1;
    font-weight: 600;
    font-size: 24px;
    color: #f03349;
    i {
      font-size: 12px;
      font-style: normal;
    }
    margin-right: 20px;
  }
  // 已报名
  .sign-up-btn-disable {
    width: 4.19rem;
    height: 1.33rem;
    background: linear-gradient(132deg, #00eb81 0%, #00c89d 100%);
    background-size: 100% 100%;
    font-weight: 500;
    font-size: 0.43rem;
    color: #ffffff;
    line-height: 0.6rem;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 0.66rem;
  }
}
</style>
